// Shape of a Dropdown answer. A single-answer dropdown stores the chosen option
// as a string; one marked "allow multiple answers" stores an array of the
// chosen options. Shared by FormFields (rendering) and excelExport (formatting).

export const isMultiSelect = (field) => field?.type === 'select' && !!field.multiple;

// Read any stored dropdown answer as a list. Tolerates the empty string that
// FormFiller seeds fields with, plus single strings left behind by a question
// that only started allowing multiple answers after it had been submitted.
export const toSelectValues = (value) => {
  if (Array.isArray(value)) return value.filter((entry) => typeof entry === 'string' && entry !== '');
  if (typeof value === 'string' && value !== '') return [value];
  return [];
};

// Keep the submitted answers in the order the author listed the options, so two
// submissions of the same form always read the same way.
export const orderedSelectValues = (value, options) => {
  const chosen = toSelectValues(value);
  const known = (Array.isArray(options) ? options : []).filter((option) => chosen.includes(option));
  const extras = chosen.filter((entry) => !known.includes(entry));
  return [...known, ...extras];
};

export const formatSelectValue = (value, options) => orderedSelectValues(value, options).join(', ');

// Toggle one option in a multi-answer dropdown, preserving the author's order.
export const toggleSelectValue = (value, option, options) => {
  const chosen = toSelectValues(value);
  const next = chosen.includes(option)
    ? chosen.filter((entry) => entry !== option)
    : [...chosen, option];
  return orderedSelectValues(next, options);
};
